import React from 'react';
import { IconButton } from '@mui/material';
import { SvgIcon } from '@mui/material';
import { motion } from 'framer-motion';

const RainCloudToggleIcon = ({
  raining = true,
  disabled = false,
  ...props
}) => {

  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fontSize="large"
      htmlColor={disabled ? '#555' : '#757575'} // OFF時は暗めに
      sx={{
        width: 28,
        height: 28,
        filter: disabled ? 'brightness(0.5)' : 'none', // さらに暗くする
      }}>
      {/* 雲部分（常にグレー） */}
      <path
        d="M18 7.5C17.5 5 15 3 12 3
         9.5 3 7.5 4.4 6.7 6.4
         4.5 6.7 3 8.4 3 10.5
         c0 2 1.6 3.5 3.5 3.5H17
         c1.9 0 3.5-1.6 3.5-3.5
         0-1.8-1.4-3.3-2.5-3.5z"
        fill="#757575"
      />

      {/* 雫（raining=trueの時だけ表示、縦長シャープ型） */}
      {raining && (
        <motion.g
          initial={{ opacity: 0, y: -4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.3 }}
          fill="#757575"
          transform="translate(0,2)"
        >
          <path d="M8 16c-0.8 1.2-0.8 2.8 0 3.6 0.8 0.8 2.2 0.8 3 0 0.8-0.8 0.8-2.4 0-3.6L9.5 14z" />
          <path d="M12 16c-0.8 1.2-0.8 2.8 0 3.6 0.8 0.8 2.2 0.8 3 0 0.8-0.8 0.8-2.4 0-3.6L13.5 14z" />
          <path d="M16 16c-0.8 1.2-0.8 2.8 0 3.6 0.8 0.8 2.2 0.8 3 0 0.8-0.8 0.8-2.4 0-3.6L17.5 14z" />
        </motion.g>
      )}

      {/* 斜め線（disabled時だけ表示） */}
      {disabled && (
        <motion.line
          x1="4"
          y1="20"
          x2="20"
          y2="4"
          stroke="#fff" // 明るめの線で強調
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.3 }}
        />
      )}
    </SvgIcon>
  );
}

const RainCloudButton = (props) => {

  // 雨雲表示切り替え
  function switchingH1(e) {
    props.setIsShowH1(!props.isShowH1)
  }

  return (
    <IconButton
      sx={{
        position: 'absolute',
        width: '29px',
        height: '29px',
        top: props.top,
        right: '10px',
        zIndex: 500,
        padding: '2px',
        border: '1px solid rgba(0, 0, 0, 0.3)',
        borderRadius: '5px',
        backgroundColor: props.isShowH1 ? 'white' : '#9b9b9b',
        '&:hover': {
          backgroundColor: props.isShowH1 ? 'rgb(243, 243, 243)' : '#9b9b9b',
        },
      }}

      onClick={switchingH1}>
      {!props.isShowH1 || props.chooseNum > 7
        ? <RainCloudToggleIcon raining={false} disabled={true} color="disabled" />
        : <RainCloudToggleIcon raining={true} disabled={false} color="primary" />

      }
    </IconButton>
  );
};

export default RainCloudButton;

